<div *ngIf="!loadError && dataLoaded">
  <div id="res-body" [@routeTransition]="animation">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</div>
